<template>
  <div >
    <el-row :gutter="40">
      <el-col :span="6">
        <div class="rect user-total">
          <div class="name-value">
            <div style="font-size: 16px;color: white">用户总量（人）</div>
            <div style="font-size: 30px;color: white;font-family:Arial">{{userTotal}}</div>
          </div>
          <img src="../../assets/images/user_total.png">
        </div>
      </el-col>
      <el-col :span="6">
        <div class="rect day-new">
          <div class="name-value">
            <div style="font-size: 16px;color: white">本日新增（人）</div>
            <div style="font-size: 30px;color: white;font-family:Arial">{{dayNew}}</div>
          </div>
          <img src="../../assets/images/day_new.png">
        </div>
      </el-col>
      <el-col :span="6">
        <div class="rect month-new">
          <div class="name-value">
            <div style="font-size: 16px;color: white">本月新增（人）</div>
            <div style="font-size: 30px;color: white;font-family:Arial">{{monthNew}}</div>
          </div>
          <img src="../../assets/images/month_new.png">
        </div>
      </el-col>
      <el-col :span="6">
        <div class="rect uv">
          <div class="name-value">
            <div style="font-size: 16px;color: white">日活跃度（UV）</div>
            <div style="font-size: 30px;color: white;font-family:Arial">{{uv}}</div>
          </div>
          <img src="../../assets/images/active.png">
        </div>
      </el-col>

    </el-row>
    <div class="container">
      <div>
        <div class="input-line">
          <div class="input-div">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;姓名&nbsp;
            <el-input style="width: 60%" placeholder="请输入用户名" v-model="sizeForm.name"></el-input>
          </div>
          <div class="input-div">
            手机&nbsp;
            <el-input style="width: 60%" placeholder="请输入手机号" v-model="sizeForm.phone"></el-input>
          </div>
          <div class="input-div">
            身份&nbsp;
            <el-select style="width: 60%" v-model="sizeForm.type">
              <el-option value="1" label="普通用户" key="1"></el-option>
              <el-option value="2" label="商户" key="2"></el-option>
              <el-option value="3" label="企业" key="3"></el-option>
            </el-select>
          </div>
        </div>
        <div class="input-line">
          时间范围&nbsp;&nbsp;
          <el-date-picker :clearable="false"  type="date" placeholder="选择查询起始时间" v-model="sizeForm.date1" style="width: 20%;" value-format="yyyy-MM-dd"></el-date-picker>
          -
          <el-date-picker :clearable="false"  type="date" placeholder="选择查询起始时间" v-model="sizeForm.date2" style="width: 20%;" value-format="yyyy-MM-dd"></el-date-picker>
          <el-button style="align-self: flex-end;margin-left: 20px" type="success" @click="getList(1)">查询</el-button>
          <el-button style="align-self: flex-end;margin-left: 20px" type="info" @click="reset">重置</el-button>
        </div>
      </div>

      <el-table
        :header-cell-style="cell"
        :row-style="row"
        :data="tableData"
        stripe
        el-table--scrollable-x
        style="width: 100%;margin-top: 20px;">
        <el-table-column
          prop="realName"
          label="姓名"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="mobileNumber"
          label="联系方式"
          align="center"
        >

        </el-table-column>
        <el-table-column
          prop="areaName"
          label="所属地区"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="sex"
          :formatter = "sexFormat"
          label="性别"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="registerTime"
          :formatter="dateFormat"
          label="注册时间"
          align="center"
        >
        </el-table-column>
        <!-- <el-table-column
          prop="account"
          label="账户余额"
          align="center"
          :formatter="toFixed"
        >
        </el-table-column> -->
        <el-table-column
          prop="identity"
          :formatter = 'typeFormat'
          align="center"
          label="身份"
          >
        </el-table-column>
        <el-table-column  label="操作" fixed="right" width="200">
          <template slot-scope="scope">
            <el-button
              size="mini"
              :type="scope.row.status ==1?'danger':'info'"
              @click="handleEdit(scope.row)">{{scope.row.status ==1?"封号":"解封"}}
            </el-button>
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="pagi"
                     layout="prev, pager, next,jumper"
                     :total="total"
                     background
                     @current-change='getList'
                     >
      </el-pagination>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <span v-if="currentData.status ==1">确认封号"{{currentData.realname}}"?封号后可进行解封。</span>
      <span v-else>确认解除对【{{currentData.realname}}】的封号？</span>

      <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="frozen">确 定</el-button>
		  </span>
    </el-dialog>

  </div>
</template>

<script>

  import {getUsers,getUserCount,frozenUser,dleUser} from '@/api/user'
  import { compareTime, toFixed } from '@/utils'
  export default {
    name: '',
    props: [''],
    data () {
      return {
        dialogVisible: false,
        name1: '',
        fenghao: '封号',
        sizeForm: {
          name: '',
          phone: '',
          date1: '',
          date2: '',
          type:'',

        },
        tableData: [],
        page:1,
        pageSize:10,
        total:0,
        dayNew:'',
        monthNew:'',
        userTotal:'',
        uv:'',
        currentData:{}
      }
    },
    mounted(){
      this.$nextTick(function () {
        this.getList(1);
        this.getCount();
      })
    },
    methods: {
      cell () {
        return {
          textAlign: 'center',
          color:'#526069',
          fontSize:'14px'
        }
      },
      row(){
        return {
          height:'36px',
          textAlign: 'center',
          color:'#7d8893',
          fontSize:'14px'
        }
      },
      getList(page){
        this.page=page;
        let { date1,date2 } = this.sizeForm;
        let flag = compareTime(date1,date2);
        if(flag){
          getUsers(this.sizeForm,page,this.pageSize).then(res=>{
            this.total = res.data.allUsers;
            this.tableData = res.data.list;
          })
        }else{
          this.$notify({
            title: "提示",
            message:'请正确选择时间',
            type:'warning',
            duration: 800
          });
        }
      },//
      getCount(){
        getUserCount().then(res=>{
          this.dayNew = res.data.userAdd;
          this.monthNew = res.data.addByMonth;
          this.uv = res.data.active;
          this.userTotal = res.data.allUser;
        })
      },
      handleEdit (row) {
        this.dialogVisible = true;
        this.currentData = row;
        this.name1 = row.name

      },
      unFrozen(){
        frozenUser(this.currentData.id,this.currentData.state,this.currentData.status).then(res=>{
          if(res.status  == 200){qe
            this.getList(this.page);
          }else{
            this.$message({
              type:'error',
              message:'操作失败'
            })
          }
          this.dialogVisible =false;
        })
      },
      frozen(){
        frozenUser(this.currentData.id,1,this.currentData.status).then(res=>{
          if(res.status  == 200){
              this.getList(this.page);
          }else{
            this.$message({
              type:'error',
              message:'操作失败'
            })
          }
          this.dialogVisible =false;
        })
      },
      handleDelete (row) {
        this.$confirm('确认删除？')
          .then(_ => {
            dleUser(row.id,1).then(res=>{
              if(res.status == 200){
                this.$message({
                  type:'success',
                  message:'删除成功'
                })
                this.getList(this.page);
              }
            })
          })
          .catch(_ => {})

      },
      handleClose (done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done()
          })
          .catch(_ => {})
      },
      dialogClose () {
        this.dialogVisible = false
        this.fenghao = '解封'

      },
      toFixed(row, column, value) {
        return toFixed(value);
      },
      dateFormat(row,column){
        return this.uwsToDate(row[column.property])
      },
      typeFormat(row,column){
        let str= '';
        let status = (row[column.property]).toString();
        status = status.replace(/,/g,"/");
        status = status.replace('1','普通用户')
        status = status.replace('2','商户管理员')
        status = status.replace('3','企业管理员')
//        switch (status) {
//          case 1:
//            str = '普通用户'
//            break;
//          case 2:
//            str= '商户管理员'
//            break;
//          case 3:
//            str= '企业管理员'
//            break;
//        }
        return status;
      },
      sexFormat(row,column){
        let str= '';
        let sex = row[column.property];
        switch (sex) {
          case 0:
            str = '未指定'
            break;
          case 1:
            str= '男'
            break;
          case 2:
            str= '女'
            break;
        }
        return str;
      },
      reset(){

        this.sizeForm.name = '';
        this.sizeForm.phone = '';
        this.sizeForm.date1 = '';
        this.sizeForm.date2 = '';
        this.sizeForm.type = '';
      }

    },
  }
</script>

<style lang='scss' scoped>
  .mian {
    width: 100%;
    height: 200px;
    background-color: #323232;
    margin-top: 20px;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }

  .anniu {
    position: absolute;
    left: 0px;
    top: 0px;
  }

  .mian div p {
    color: #ffffff;
    font-size: 18px;
    padding-top: 20px;
  }

  .mian div span {
    color: #FFFFFF;
    font-size: 32px;
  }

  .rect {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 84px;
    width: 100%;
  }

  .user-total {
    background-color: #409EFF;
  }

  .day-new {
    background-color: #795da3;
  }

  .month-new {
    background-color: #67c23a;
  }

  .uv {
    background-color: #66B1FF;
  }

  .name-value {
    align-self: center;
    margin-left: 10%;
  }
  .container{
    display: flex;
    flex-direction: column;
    background-color: white;
    padding: 30px;
    margin-top: 20px;
  }
  .input-line{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 10px;
  }
  .input-div{
    width: 20%;
  }
  .pagi{
    align-self: center;
    margin-top: 24px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/index.vue